import { oneLine, replaceWithLink } from 'utils/formatting';
export const SINGLE_SITE_STUDY_TYPE = 1;
export const MULTICENTER_STUDY = 2;
export const plannedNumberOfSitesList = [
    { title: 'Single site study', value: SINGLE_SITE_STUDY_TYPE },
    { title: 'Multicenter study', value: MULTICENTER_STUDY },
];
export const anticipatedNumberOfSitesList = [
    { title: '2-10', value: 1 },
    { title: '11-25', value: 2 },
    { title: '26-100', value: 3 },
    { title: 'More than 100', value: 4 },
];
export const responsiblePartyTypesList = [
    { title: 'Principal Investigator', value: 1 },
    { title: 'Sponsor', value: 2 },
    { title: 'Sponsor-Investigator', value: 3 },
];
export const responsiblePartyTypes2List = [
    { title: 'Principal Investigator', value: 1 },
    { title: 'Sponsor', value: 2 },
];
export const CLINICAL_TRIAL = 1;
export const COMPASSIONATE_USE = 2;
export const clinicalTrialTypeList = [
    {
        title: 'Observational',
        value: 1,
        tooltipInfo: 'In observational trials, researchers do not assign participants to a treatment or other intervention. Instead, researchers observe participants or measure certain outcomes to determine health outcomes.',
    },
    {
        title: 'Interventional',
        value: 2,
        tooltipInfo: 'In interventional trials, participants are assigned to receive one or more interventions (or a placebo or no intervention) so that researchers can evaluate the effects of the interventions on biomedical or health-related outcomes.',
    },
    {
        title: 'Patient Registry',
        value: 3,
        tooltipInfo: 'A patient registry is "an organized system that uses observational study methods to collect uniform data (clinical and other) to evaluate specified outcomes for a population defined by a particular disease, condition or exposure, and that serves a predetermined scientific, clinical or policy purpose.”',
    },
];
export const compassionateUseTypeList = [
    {
        title: 'Individual Patient IND',
        value: 1,
        tooltipInfo: 'Or equivalent regulatory pathway providing access to an investigational product for use by a single patient.  Nomenclature for this pathway can vary both within and across regulatory jurisdictions e.g. expanded access, right-to-try, named patient use, special access scheme.',
    },
    {
        title: 'Intermediate Size Patient Population IND',
        value: 2,
        tooltipInfo: 'Or equivalent regulatory pathway providing access to an investigational product for more than one patient, but generally fewer patients that are treated under a typical IND or protocol.  Nomenclature for this pathway can vary both across regulatory jurisdictions.',
    },
    {
        title: 'Treatment IND/Protocol',
        value: 3,
        tooltipInfo: 'Or equivalent regulatory pathway providing access to an investigational product for treatment use by a large (widespread) population.  Nomenclature for this pathway can vary both across regulatory jurisdictions.',
    },
];
export const clinicalTrialPhasesList = [
    {
        title: 'Early Phase 1: Exploratory trials involving very limited human exposure',
        value: 7,
        tooltipWidth: '200px',
        tooltipInfo: '',
    },
    {
        title: 'Phase 1: Initial drug introduction',
        value: 1,
        tooltipWidth: '200px',
        tooltipInfo: 'The initial introduction of an investigational new drug into humans. Phase 1 studies are typically closely monitored and may be conducted in patients or normal subjects. These studies are designed to determine the metabolism and pharmacologic actions of the drug in humans, the side effects associated with increasing doses, and, if possible, to gain early evidence on effectiveness. During Phase 1, sufficient information about the drug’s pharmacokinetics and pharmacological effects should be obtained to permit the design of well-controlled, scientifically valid, Phase 2 studies. The total number of subjects and patients included in Phase 1 studies varies with the drug, but is generally in the range of 20 to 80. Phase 1 studies also include studies of drug metabolism, structure-activity relationships, and mechanism of action in humans, as well as studies in which investigational drugs are used as research tools to explore biological phenomena or disease processes. [FDA]',
    },
    {
        title: 'Phase 2: Controlled clinical studies of drug effectiveness',
        value: 2,
        tooltipWidth: '200px',
        tooltipInfo: 'Controlled clinical studies conducted to evaluate the effectiveness of the drug for a particular indication or indications in patients with the disease or condition under study and to determine the common short-term side effects and risks associated with the drug. Phase 2 studies are typically well controlled, closely monitored, and conducted in a relatively small number of patients, usually involving no more than several hundred subjects. [FDA]',
    },
    {
        title: 'Phase 3: Additional (un)controlled trials to determine drug effectiveness',
        value: 3,
        tooltipWidth: '200px',
        tooltipInfo: 'Studies are expanded controlled and uncontrolled trials. They are performed after preliminary evidence suggesting effectiveness of the drug has been obtained, and are intended to gather the additional information about effectiveness and safety that is needed to evaluate the overall benefit-risk relationship of the drug and to provide an adequate basis for physician labeling. Phase 3 studies usually include from several hundred to several thousand subjects. [FDA] NOTE: Phase 3b studies are a sub category of Phase 3 trials near the time of approval to elicit additional findings.',
    },
    {
        title: "Phase 4: Postmarketing studies of risks, benefits, and optimal drug's use",
        value: 4,
        tooltipWidth: '200px',
        tooltipInfo: 'Concurrent with marketing approval, FDA may seek agreement from the sponsor to conduct certain postmarketing (Phase 4) studies to delineate additional information about the drug’s risks, benefits, and optimal use. These studies could include, but would not be limited to, studying different doses or schedules of administration than were used in Phase 2 studies, use of the drug in other patient populations or other stages of the disease, or use of the drug over a longer period of time. [FDA]',
    },
    {
        title: 'Phase 5: Postmarketing surveillance',
        value: 5,
        tooltipWidth: '200px',
        tooltipInfo: 'Postmarketing surveillance is sometimes referred to as Phase 5.',
    },
];
export const descriptionOfStudyDesignList = [
    { title: 'Parallel group', value: 1 },
    { title: 'Cross-over', value: 2 },
    { title: 'Factorial', value: 3 },
    { title: 'Other', value: 4 },
];
export const investigationalProductTypeList = [
    { title: 'Chemical origin', value: 1 },
    { title: 'Contains genetically modified organisms', value: 2 },
    { title: 'Homeopathic medicinal product', value: 3 },
    { title: 'Herbal medicinal product', value: 4 },
    {
        title: 'Immunological medicinal product [vaccine, allergen,mimmune serum]',
        value: 5,
    },
    { title: 'Radiopharmaceu tical product', value: 6 },
    { title: 'Gene therapy product', value: 7 },
    { title: 'Cell therapy product', value: 8 },
    { title: 'Biological/biotec hnological origin', value: 9 },
    { title: 'Device', value: 10 },
    { title: 'Diagnostic agent (in vivo, in vitro)', value: 11 },
    { title: 'Food', value: 12 },
    { title: 'Other', value: 13 },
];
export const genderList = [
    { title: 'Male', value: 1 },
    { title: 'Female', value: 2 },
    { title: 'All', value: 3 },
];
export const genderListPatient = [
    { title: 'Male', value: 1 },
    { title: 'Female', value: 2 },
    { title: 'Other', value: 3 },
    { title: 'Unknown', value: 4 },
];
export const genderListPatientNew = [
    { title: 'Male', value: 1 },
    { title: 'Female', value: 2 },
    { title: 'Unknown', value: 3 },
];
export const subjectRacesList = [
    { title: 'White', value: 1 },
    { title: 'Black or African American', value: 2 },
    { title: 'American Indian or Alaska Native', value: 3 },
    { title: 'Asian Indian', value: 4 },
    { title: 'Chinese', value: 5 },
    { title: 'Filipino', value: 6 },
    { title: 'Japanese', value: 7 },
    { title: 'Korean', value: 8 },
    { title: 'Vietnamese', value: 9 },
    { title: 'Other Asian', value: 10 },
    { title: 'Native Hawaiian', value: 11 },
    { title: 'Guamanian or Chamorro', value: 12 },
    { title: 'Samoan', value: 13 },
    { title: 'Other Pacific Islander', value: 14 },
];
export const subjectEthnicityList = [
    { title: 'No, not of Hispanic, Latino/a, or Spanish origin', value: 1 },
    { title: 'Yes, Mexican, Mexican American, Chicano/a', value: 2 },
    { title: 'Yes, Puerto Rican', value: 3 },
    { title: 'Yes, Cuban', value: 4 },
    { title: 'Yes, Another Hispanic, Latino/a or Spanish origin', value: 5 },
];
export const trialPurposeClassificationList = [
    { title: 'Proof of efficacy', value: 1 },
    { title: 'Dose finding', value: 2 },
    { title: 'Physician education', value: 3 },
    { title: 'Safety study', value: 4 },
    { title: 'Special populations', value: 5 },
    { title: 'Long term safety', value: 6 },
    { title: 'Health economics', value: 7 },
    { title: 'Compassionate use', value: 8 },
    { title: 'Other', value: 9 },
];
export const radioDataList = [
    { value: true, title: 'Yes' },
    { value: false, title: 'No' },
];
export const blindingDesignList = [
    { title: 'Open', value: 1 },
    { title: 'Single blind', value: 2 },
    { title: 'Double blind', value: 3 },
];
export const randomizationProceduresList = [
    { title: 'Randomized', value: 1 },
    { title: 'Non-randomized', value: 2 },
];
export const routeAdministrationList = [
    { title: 'BUCCAL', value: 1 },
    { title: 'DENTAL', value: 2 },
    { title: 'ENDOCERVICAL', value: 3 },
    { title: 'ENDOTRACHEAL', value: 4 },
    { title: 'ENTERAL', value: 5 },
    { title: 'IMPLANTATION', value: 6 },
    { title: 'INHALATION', value: 7 },
    { title: 'INJECTION', value: 8 },
    { title: 'INTERSTITIAL', value: 9 },
    { title: 'INTRA-ANAL', value: 10 },
    { title: 'INTRA-ARTERIAL', value: 11 },
    { title: 'INTRA-ARTICULAR', value: 12 },
    { title: 'INTRACRANIAL', value: 13 },
    { title: 'INTRADERMAL', value: 14 },
    { title: 'INTRAMUSCULAR', value: 15 },
    { title: 'INTRAOCULAR', value: 16 },
    { title: 'INTRAOSSESOUS', value: 17 },
    { title: 'INTRAPERITONEAL', value: 18 },
    { title: 'INTRAPLEURAL', value: 19 },
    { title: 'INTRATHECAL', value: 20 },
    { title: 'INTRATRACHEAL', value: 21 },
    { title: 'INTRAUTERINE', value: 22 },
    { title: 'INTRAVENOUS', value: 23 },
    { title: 'INTRAVESICAL', value: 24 },
    { title: 'INTRAVITREAL', value: 25 },
    { title: 'IRRIGATION IV (INFUSION)', value: 26 },
    { title: 'N/A', value: 27 },
    { title: 'NASAL', value: 28 },
    { title: 'OPHTHALMIC', value: 29 },
    { title: 'ORAL', value: 30 },
    { title: 'ORAL-21', value: 31 },
    { title: 'ORAL-28', value: 32 },
    { title: 'OTIC PERFUSION, CARDIAC', value: 33 },
    { title: 'PERIODONTAL', value: 34 },
    { title: 'RECTAL', value: 35 },
    { title: 'SPINAL', value: 36 },
    { title: 'SUBCUTANEOUS', value: 37 },
    { title: 'SUBLINGUAL', value: 38 },
    { title: 'TOPICAL', value: 39 },
    { title: 'TRANSDERMAL', value: 40 },
    { title: 'TRANSMUCOSAL URETHRAL', value: 41 },
    { title: 'VAGINAL', value: 42 },
];
export const studyDocumentsList = [
    {
        name: 'confidentialityAgreementDraft',
        title: 'Confidentiality Agreement (Draft)',
        description: oneLine `
      A document between the sponsor and an outside party (Investigator or Institution)
      that defines the terms and basic criteria to assure that the party (or parties) receiving
      confidential information will maintain confidentiality and will not use that information
      for any purpose other than that described in the Agreement. May also be present in
      the Clinical Trial Agreement. A copy of a Completed Confidentiality Agreement should
      be added to a study application record following approval of an application.`,
        tooltipInfo: '',
        class: 'mt-7',
        count: 1,
    },
    {
        name: 'clinicalTrialProtocol',
        title: 'Clinical Trial Protocol',
        description: oneLine `
      A document that describes the objective(s), design, methodology, statistical considerations, and organization of a trial.
      The protocol usually also gives the background and rationale for the trial but these could be provided
      in other protocol-referenced documents. Throughout the ICH GCP Guideline, the term protocolrefers to protocol
      and protocol amendments.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'investigatorBrochure',
        title: "Investigator's Brochure",
        description: oneLine `
      A document that provides relevant and current clinical and non-clinical data on the investigational product(s)
      that is related to the study of the product(s) in human subjects.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'protocolAmendment',
        title: 'Protocol Amendment',
        description: oneLine `
      A document that describes change(s) to or formal clarification of a protocol.
      Includes justification for a non-substantial amendment, such as administrative changes.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'sponsorDraftConsentForm',
        title: 'Sponsor Draft (Recommended) Consent Form',
        description: oneLine `
      A document that descibes that the appropriate written information (content and wording) has been given to subjects regarding the trial to support their ability to give fully informed consent and to document their consent to trial participation in writing. If applicable, must also include the child assent form (blank model / template). Please note that core template is Trial level, the country template is country level and the site template is at the site level`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'sponsorDraftAssentForm',
        title: 'Sponsor Draft (Recommended) Assent Form',
        description: oneLine `
      The assent is in addition to the consent and signals the child's willing cooperation in the study.
      An Informed Assent Form does not replace a consent form signed by parents or guardians.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'subjectInformationSheetDraft',
        title: 'Subject Information Sheet (Draft)',
        description: oneLine `
      A document that descibes information provided to subjects to support their decision about
      whether or not to participate in the trial.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'irBorIECApprovalNotice',
        title: 'IRB/IEC Approval Notice',
        description: oneLine `
      Documentation received from IRB/IEC in response to submission indicating approval/acknowledgement of trial and any specifications or modifications. Records referenced by the approval (such as a Protocol that has been approved) should be filed elsewhere in the TMF, as appropriate, as long as there is identification of the approved record within the IRB/IEC letter or acknowledgement.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'clinicalTrialAgreementOrMaterialTransferAgreementDraft',
        title: 'Draft Clinical Trial Agreement or Material Transfer Agreement',
        description: oneLine `
      To document agreement of trial requirements between sponsor or 3rd Party and site/ PI.
      Includes indemnity unless separate document created.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'pharmacyManual',
        title: 'Pharmacy Manual',
        description: oneLine `
      To instruct on how the IP should be handled during transit and stored upon arrival at the distribution center,
      depot and/or trial site. Should address expectations for adequate and safe receipt, handling, storage, dispensing,
      retrieval of unused product from subjects and return of unused IP to the sponsor (or their delegate) If appropriate to the trial,
      includes preparation of the IP leading to administration and administration instructions.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'seriousAdverseEventForm',
        title: 'Serious Adverse Event Form',
        description: `${oneLine `
      A form to capture and report a serious adverse event (SAE) in a human clinical trial,
      that is defined as any untoward medical occurrence that at any dose:`}
      1. Results in death
      2. Is life-threatening
      3. Requires inpatient hospitalization or causes prolongation of existing hospitalization
      4. Results in persistent or significant disability/incapacity,
      5. May have caused a congenital anomaly/birth defect, or
      6. Requires intervention to prevent permanent impairment or damage.`,
        tooltipInfo: '',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'otherDocuments',
        title: 'Other Study Documents',
        description: '',
        tooltipInfo: '',
        class: 'mt-10 mb-10',
        count: 20,
    },
];
export const linkLOA = 'https://www.fda.gov/news-events/expanded-access/example-wording-letter-authorization-loa-individual-patient-expanded-access-ind';
export const sponsorDocumentsList = [
    {
        name: 'letterOfAuthorization',
        title: 'Letter of Authorization (optional)',
        fieldTitle: 'Letter of Authorization',
        description: replaceWithLink `
      A Letter of Authorization (LOA) from the biopharmaceutical company that makes the investigational drug you wish to obtain, grants the right of reference to the information contained in the supplier's existing Investigational New Drug (IND) application. If a LOA is not available, submit sufficient information is submitted for FDA to assure the product’s quality. A ${linkLOA} is available from FDA.
    `,
        class: 'mt-10',
        count: 1,
    },
];
export const applicationDocumentsList = [
    {
        name: 'confidentialityAgreement',
        title: 'Confidentiality Agreement',
        description: oneLine `
      A document between the sponsor and an outside party (Investigator or Institution)
      that defines the terms and basic criteria to assure that the party (or parties) receiving
      confidential information will maintain confidentiality and will not use that information
      for any purpose other than that described in the Agreement. May also be present in
      the Clinical Trial Agreement.`,
        class: 'mt-7',
        count: 1,
    },
    {
        name: 'principalInvestigatorCurriculumVitae',
        title: 'Principal Investigator Curriculum Vitae',
        description: oneLine `
      A document that describes qualifications and eligibility of the Principal Investigator
      to conduct trial and/or provide medical supervision of subjects. To include updates,
      one-page CVs and biographical sketches.`,
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'siteConsentForm',
        title: 'Site Consent Form',
        description: oneLine `
      A document that descibes that the appropriate written information (content and wording)
      has been given to subjects regarding the trial to support their ability to give fully informed
      consent and to document their consent to trial participation in writing.
      If applicable, must also include the child assent form (blank model / template).
      Please note that core template is Trial level, the country template is country level
      and the site template is at the site level.`,
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'siteAssentForm',
        title: 'Site Assent Form',
        description: oneLine `
      A document developed for young people (7 to 13 years of age) who can read.
      The Assent Form provides simple written assent forms for young people are presented
      with the option of research.`,
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'irbOrIECApprovalNotice',
        title: 'IRB/IEC Approval Notice',
        description: oneLine `
      Documentation received from IRB/IEC in response to submission indicating approval/acknowledgement
      of trial and any specifications or modifications. Records referenced by the approval
      (such as a Protocol that has been approved) should be filed elsewhere in the TMF, as appropriate,
      as long as there is identification of the approved record within the IRB/IEC letter or acknowledgement.`,
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'fullyExecutedContractClinicalTrialAgreementOrMaterialTransferAgreement',
        title: 'Fully Executed Contract (Clinical Trial Agreement/Material Transfer Agreement)',
        description: oneLine `
      To document agreement of trial requirements between sponsor or 3rd Party and site/ PI.
      Includes indemnity unless separate document created.`,
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'formFDA1572',
        title: 'Form FDA 1572',
        description: 'For IND trial, 1572 must be completed globally for FDA submission.',
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'financialDisclosureForm',
        title: 'Financial Disclosure Form',
        description: oneLine `
      A document that describes financial disclosures, certification documentation and conflicts of interest,
      which include but are not limited to: completed disclosure forms of financial interests and arrangements
      of clinical investigators (e.g. FDA Form 3455/3454, NIH COI , clinical investigator financial certification (Canada)).`,
        class: 'mt-10',
        count: 1,
    },
    {
        name: 'otherDocuments',
        title: 'Other Application Documents',
        description: '',
        class: 'mt-10 mb-10',
        count: 20,
    },
];
export const womenOfChildbearingPotentialList = [
    { title: 'Pre-pubertal', value: 1 },
    { title: 'Women of child bearing potential', value: 2 },
    { title: 'Sterile women', value: 3 },
    { title: 'Post-menopausal', value: 4 },
    { title: 'Lactating', value: 5 },
];
export const vulnerablePopulationList = [
    { title: 'Children', value: 1 },
    { title: 'Pregnant women', value: 2 },
    { title: 'Prisoners', value: 3 },
    { title: 'Mentailly Handicapped', value: 4 },
];
export const ageClassificationsList = [
    { title: 'In-utero', value: 1, minMinAge: 0, disabled: true },
    { title: 'Preterm newborn', value: 2, minMinAge: 0, disabled: true },
    { title: 'Neonate (0-27 days)', value: 3, minMinAge: 0, disabled: true },
    {
        title: 'Infant and toddler (28 days to 23 months)',
        value: 4,
        minMinAge: 0,
        maxMinAge: 2,
        disabled: true,
    },
    {
        title: 'Child (2-11 years)',
        value: 5,
        minMinAge: 2,
        maxMinAge: 12,
        disabled: true,
    },
    {
        title: 'Adolescent (12-18 years)',
        value: 6,
        minMinAge: 12,
        maxMinAge: 18,
        disabled: true,
    },
    {
        title: 'Adult (18-65 years)',
        value: 7,
        minMinAge: 18,
        maxMinAge: 66,
        disabled: true,
    },
    {
        title: 'Elderly/Geriatric (>65 years)',
        value: 8,
        minMinAge: 66,
        maxMinAge: 999,
        disabled: true,
    },
];
export const pregnancyStatusList = [
    { title: 'Pregnant', value: true },
    { title: 'Not pregnant', value: false },
];
export const lactationStatusList = [
    { title: 'Lactating', value: true },
    { title: 'Not lactating', value: false },
];
export const periodDateList = [
    { title: 'Not chosen', value: null },
    { title: 'Before', value: 1 },
    { title: 'After', value: 2 },
    { title: 'Date range', value: 3 },
];
export const labTestStandard = [
    { title: 'Conventional', value: 'Conventional' },
    { title: 'International Standard', value: 'International' },
];
export const applicationStatusList = [
    { title: 'New', value: 1 },
    { title: 'In progress', value: 2 },
    { title: 'Requested additional information', value: 3 },
    { title: 'Re-submitted', value: 4 },
    { title: 'Approved', value: 5 },
    { title: 'Declined', value: 6 },
    { title: 'Withdrawn', value: 7 },
];
export const reasonForDecliningApplicationCTList = [
    { title: 'Additional site activation(s) not required', value: 1 },
    { title: 'Study on temporary hold  / Study on Permanent Hold', value: 2 },
    { title: 'Required documentation not provided', value: 3 },
    { title: 'Study complete', value: 4 },
    { title: 'Patient ineligible', value: 5 },
    { title: 'Investigating physician ineligible', value: 6 },
    { title: 'Site capabilities prevent participation', value: 7 },
    { title: 'IP development discontinued', value: 8 },
    { title: 'Other (please specify)', value: 9 },
];
export const reasonForDecliningApplicationCUList = [
    { title: 'Additional site activation(s) not required', value: 1 },
    { title: 'Study on temporary hold  / Study on Permanent Hold', value: 2 },
    { title: 'Required documentation not provided', value: 3 },
    { title: 'Study complete', value: 4 },
    { title: 'Patient ineligible', value: 5 },
    { title: 'Investigating physician ineligible', value: 6 },
    { title: 'Site capabilities prevent participation', value: 7 },
    { title: 'IP development discontinued', value: 8 },
    { title: 'No treatment plan provided (compassionate use only)', value: 9 },
    { title: 'Insufficient funds (compassionate use only)', value: 10 },
    { title: 'IP supply unavailable (compassionate use only)', value: 11 },
    {
        title: 'Lack of resources to administer application (compassionate use only)',
        value: 12,
    },
    { title: 'Other (please specify)', value: 13 },
];
export const radioListOrganizations = [
    { value: 1, title: 'Sponsor' },
    { value: 2, title: 'Research Site(s)' },
];
